export default __webpack_public_path__ + "assets/jamespot-2025-216.d681af07a093035b056f3a3589dfb6f8.png";